import { createContext } from 'react'
import { Citation } from '../../../../../../../../views/AIAgent/AIAgentResultCitations/AIAgentResultCitations'

export interface CitationNodeContextData {
  citations: Citation[]
}

export const defaultCitationNodeContextData: CitationNodeContextData = { citations: [] }

export const CitationNodeContext = createContext<CitationNodeContextData>(defaultCitationNodeContextData)
